import * as React from 'react'

import {
  ConversationStreamStatuses,
  useConversationStream,
  type ConversationBootstrap,
  type UseConversationStreamResult,
} from '../hooks/useConversationStream'

export type ConversationContextValue = UseConversationStreamResult

const DEFAULT_CONTEXT: ConversationContextValue = {
  items: [],
  status: ConversationStreamStatuses.IDLE,
  thinkingLabel: null,
  telemetry: [],
  conversationId: null,
  sendMessage: () => false,
  sendSilentMessage: () => false,
  sendTechnicalMessage: () => null,
}

export const ConversationContext =
  React.createContext<ConversationContextValue>(DEFAULT_CONTEXT)

export const ConversationProvider = ({
  bootstrap,
  children,
}: React.PropsWithChildren<{ bootstrap: ConversationBootstrap }>) => {
  const conversation = useConversationStream(bootstrap)

  return (
    <ConversationContext.Provider value={conversation}>
      {children}
    </ConversationContext.Provider>
  )
}

export const useConversation = (): ConversationContextValue =>
  React.useContext(ConversationContext)
